<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="category-list">
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="页面路径">
              <el-input v-model="formInline.link" placeholder="页面路径"></el-input>
            </el-form-item>
            <el-form-item label="页面名称">
              <el-input v-model="formInline.title" placeholder="页面名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 分类列表 -->
        <el-table
            v-loading="tableLoading"
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column
              width="140"
              prop="title"
              label="页面名称">
          </el-table-column>

          <el-table-column
              width="300"
              prop="link"
              label="页面路径">
          </el-table-column>

          <el-table-column
              label="页面参数">
            <template slot-scope="scope">
              <el-input v-if="scope.row.params"  v-model="scope.row.linkParams" :placeholder="scope.row.params"></el-input>
            </template>
          </el-table-column>

          <el-table-column
              label="操作"
              width="60">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="selectLink(scope.row)">选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagation" v-show="tableData.length > 0">
          <el-pagination
              layout="total, prev, pager, next"
              :total="page.totalCount"
              :page-size='page.pageSize'
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>



    </div>
  </div>
</template>
<script>
import {Message, Loading} from 'element-ui';

export default {
  name: 'category',
  props: {
    source:'',
  },
  data() {
    return {
      tableData: [],
      setTableData: [],
      dialogVisible: false,
      handleType: '', //操作分类的类型 'add'新增分类 'edit'编辑分类
      title: '',
      delBox: false,
      delData: {},
      tableLoading: true,
      linkParams: '',

      formInline: {
        link: '',
        title: '',
        source: this.source
      },
      LinkForm: {
        source: null,
        link: null,
        title: null,
        source_name: null,
        params: null,
        description: null,
      },

      page: {
        pageNumber: 1,
        pageSize: 6,
        pageCount: 6,
        currentPage: 0,
        totalCount: 0
      },
    }
  },
  mounted() {
    // this.getLinkList('get');
  },
  watch:{
    source: function(val){
      this.formInline.source = val;
      this.getLinkList('get');
    }
  },
  created(){
    this.getLinkList('get');
  },
  methods: {
    selectLink(item){
      if(item.params && !item.linkParams){
        this.$message.error("请填写跳转路径参数!");
        return
      }
      this.$emit('select',item);
    },
    handleSizeChange: function (val) {
      console.log(val,1)
    },
    handleCurrentChange: function (val) {
      this.page.currentPage = val-1;
      this.getLinkList(val);
    },
    onSearch: function (){
      this.getLinkList('search');
    },
    // 获取分类列表
    getLinkList: function (type) {
      let params = {
        page: this.page.currentPage,
        count: this.page.pageSize,
      }
      params.source = this.formInline.source;
      params.link = this.formInline.link;
      params.title = this.formInline.title;
      lib.tmsapi.get({
        api: 'api/test/router/list',
        data: params,
        success: (res) => {
          if (res.data) {
            this.tableLoading = false;
            this.tableData = res.data || [];
            this.page.totalCount = res.total;
          }
        },
      })

    },
  },
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  margin: 20px auto;
  width: 100%;
}

.pagation{
  float: right;
}

.category-list header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-list header h3 {
  flex: 1;
}


.category-manage header {
  display: flex;
  align-items: center;
  margin: 10px;
}

.category-manage small {
  font-size: 12px;
  color: #bbb;
  padding-left: 5px;
}

.category-manage .radio-button {
  margin: 0 10px 10px 10px;
  width: 150px;
  text-align: center;
}
</style>

